<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <Breadcrumbs main="UK Emission Intensity" title="default" />

  <div class="container-fluid p-0">
    <div class="row widget-grid">
      <div class="px-2">
      <FilterS2
        :periodNameProp="'Current MP'"
        @filterHandle="analyticsFilterHandle" 
        />
      </div>

      <el-row class="m-0 width-100-p mt-3">
        <el-col class="d-flex align-item-center px-1" :span="24">
          <div
            class="row m-0 bg-me-primary border-color-light width-100-p rounded-4"
          >
            <el-col :span="24">
              <h5 class="text-white mt-3 ml-1">
                UK Emission Intensity by Region and Time (London)
              </h5>
            </el-col>
            <el-col
              :span="24"
              v-loading="loading"
              :element-loading-spinner="svg"
              element-loading-svg-view-box="-10, -10, 50, 50"
              element-loading-background="rgba(122, 122, 122, 0.8)"
            >
              <div id="chart">
                <apexchart
                  :key="chartOneKey"
                  type="line"
                  height="350"
                  :options="intensityChartOptions"
                  :series="intensitySeries"
                ></apexchart>
              </div>
            </el-col>
          </div>
        </el-col>
      </el-row>

      <!-- update uk emission intensity filter -->
      <div
        v-if="$store.state.auth.user != null && !$store.state.auth.user.is_auditor"
        class="px-2"
      >
      <FilterS10
        :periodNameProp="'Current MP'"
        @handleUpdateUKIntensity="handleUpdateUKIntensity" 
        @handleDeleteUKIntensity="handleDeleteUKIntensity"
        />
      </div>      
    </div>

  </div>
</template>

<script>
// import Filter from "../common/filter.vue";
import FilterS2 from "@/pages/dashboard/common/filter-s2.vue";
import FilterS10 from "@/pages/dashboard/common/filter-s10.vue";
import {
  errorIntensityChart,
} from "./config.js";
import UserService from "../../../services/user.service";
import { ElMessageBox } from "element-plus";
import { addTaskIdtoSessionStorage, createCeleryTaskPoller } from "../common/pollingCeleryTask";
export default {
  props: {
    propCardData: {
      type: Object,
      default: null,
    },
    propCardDataList: {
      type: Array,
      default: null,
    },
  },
  components: {
    // Filter,
    FilterS2,
    FilterS10,
  },
  watch: {},
  data() {
    return {
      chartOneKey: 0,
      loadingChart: false,
      loading: false,
      intensitySeries: errorIntensityChart.series,
      intensityChartOptions: errorIntensityChart.chartOptions,
      filter: {
        startDate: null,
        endDate: null,
      },
      updateUKIntensityFilter: {
        startDate: null,
        endDate: null,
      },
    };
  },
  mounted() {
    // this.getDailyEmission();
  },
  methods: {
    resetChart() {
      this.chartOneKey++;
    },
    handleUpdateUKIntensity(event) {
      this.updateUKIntensityFilter = event;
      const message = `<span class="moderat-meGreen">Update UK emission intensity for period:</span> <br> 
      ${this.updateUKIntensityFilter.startDate} to ${this.updateUKIntensityFilter.endDate}`;
      ElMessageBox.confirm(message, 'Confirm', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'confirm',
        dangerouslyUseHTMLString: true,
      }).then(() => {
        this.updateUKIntensity();
      }).catch(() => {
        this.$message.error("Update UK emission intensity cancelled");
        return;
      });
    },
    handleDeleteUKIntensity(event) {
      this.deleteUKIntensityFilter = event;
      const message = `<span class="moderat-meGreen">Delete UK emission intensity for period:</span> <br> 
      ${this.deleteUKIntensityFilter.startDate} to ${this.deleteUKIntensityFilter.endDate} <br> 
      <span class="moderat-meGreen">This action cannot be undone!</span>`;
      ElMessageBox.confirm(message, 'Confirm', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning',
        dangerouslyUseHTMLString: true,
      }).then(() => {
        this.deleteUKIntensity();
      }).catch(() => {
        this.$message.error("Delete UK emission intensity cancelled");
        return;
      });
    },
    analyticsFilterHandle(event) {
      this.filter = event;
      this.analyticsUkEmissionIntensity();
    },
    async testUkEmissionIntensity() {
      await UserService.testUkEmissionIntensity().then(
        (response) => {
          console.log(response.data);
        }
      );
    },
    async updateUKIntensity() {
      let body = null;
      body = {
        start_time: this.updateUKIntensityFilter.startDate,
        end_time: this.updateUKIntensityFilter.endDate,
        command: "update",
      };

      await UserService.customPeriodUkEmissionIntensity(body).then(
        (response) => {
          if (!response.data.data || !response.data.data.task_id) {
            console.log("Invalid response structure, task_id is not found in response");
            return;
          }

          // console.log(response.data);

          const taskId = response.data.data.task_id;
          addTaskIdtoSessionStorage('uk_emission_intensity_update', taskId, 'PENDING', 'updateUKIntensity', {});

          // msg user
          this.$message.success("Update UK emission intensity task started, please wait for results");

          // create poller
          const poller = createCeleryTaskPoller(taskId, 15000, 'uk_emission_intensity_update');
          this.ukEmissionIntensityUpdatePoller = poller;

          // start polling
          poller.startPolling();
        }
      ).catch(
        (error) => {
          if (error.response.status == 401 || error.response.status == 403) {
            this.$router.push({
              path: "/",
            });
            return;
          } else {
            this.$message.error("Error updating UK emission intensity: " + error.response.data.message);
            this.loading = false;
            return;
          }
        }
      );
    },
    async analyticsUkEmissionIntensity() {
      // this.resetChart();
      let body = null;
      body = {
        start_time: this.filter.startDate,
        end_time: this.filter.endDate,
        command: "analytics",
      }
      this.loading = true;
      await UserService.customPeriodUkEmissionIntensity(body).then(
        (response) => {
          if (!response.data.data || !response.data.data.length > 0) {
            console.log("Invalid response structure, data is not found or empty in response");
            this.$message.error("No data found for the selected period");
            this.loading = false;
            return;
          }
          const region_mapping = {
            'north_scotland': 'North Scotland',
            'south_scotland': 'South Scotland',
            'north_west_england': 'North West England',
            'north_east_england': 'North East England',
            'yorkshire': 'Yorkshire',
            'north_wales_and_merseyside': 'North Wales and Merseyside',
            'south_wales': 'South Wales',
            'west_midlands': 'West Midlands',
            'east_midlands': 'East Midlands',
            'east_england': 'East England',
            'south_west_england': 'South West England',
            'south_england': 'South England',
            'london': 'London',
            'south_east_england': 'South East England',
            'northern_ireland': 'Northern Ireland',
          }

          const data = response.data.data; // This is now an array of objects
          let series = [];
          let categories = [];
          
          // Extract categories from time field first
          if (data.length > 0 && data[0].time) {
            categories = data.map(item => item.time);
          }
          
          // Create series for each region
          Object.keys(data[0]).forEach(key => {
            if (key !== 'time' && key !== 'updated_at' && key !== 'record_count' && key !== 'month') {
              series.push({ 
                name: region_mapping[key], 
                data: data.map(item => item[key]) 
              });
            }
          });
          
          this.intensitySeries = series;
          // Create a new object to ensure reactivity
          this.intensityChartOptions = {
            ...this.intensityChartOptions,
            xaxis: {
              ...this.intensityChartOptions.xaxis,
              categories: categories
            }
          };
          // console.log(series);
          // console.log(categories);
        }).catch(
          (error) => {
            if (error.response.status == 401 || error.response.status == 403) {
              this.$router.push({
                path: "/",
              });
              return;
            } else {
              this.$message.error("Error getting UK emission intensity: " + error.response.data.message);
            }
          } 
        ).finally(() => {
          this.loading = false;
        });
    },

    async deleteUKIntensity() {
      let body = null;
      body = {
        start_time: this.deleteUKIntensityFilter.startDate,
        end_time: this.deleteUKIntensityFilter.endDate,
        command: "delete",
      };
      await UserService.customPeriodUkEmissionIntensity(body).then(
        (response) => {
          if (!response.data.data || !response.data.data.total_deleted_records) {
            console.log("Invalid response structure, total_deleted_records is not found in response");
            this.$message.error("Error deleting UK emission intensity: " + response.data.message);
            return;
          }
          let totalDeleted = response.data.data.total_deleted_records;
          this.$message.success(`UK emission intensity deleted successfully, ${totalDeleted} records deleted.`);
          this.analyticsUkEmissionIntensity();
        }).catch(
          (error) => {
            if (error.response.status == 401 || error.response.status == 403) {
              this.$router.push({
                path: "/",
              });
              return;
            } else {
              this.$message.error("Error deleting UK emission intensity: " + error.response.data.message);
            }
          }
        );
    },
  },
};
</script>

<style></style>
